// utils/validation.js
export const ERROR_MESSAGES = {
  required: "This field is required",
  email: "Please enter a valid email address",
  minLength: (len) => `Minimum ${len} characters required`,
  maxLength: (len) => `Maximum ${len} characters allowed`,
  pattern: "Invalid format",
};

export function validateForm(values, rules) {
  const errors = {};

  for (const field in rules) {
    const value = values[field]?.toString().trim() || "";
    const rule = rules[field];
    const label = rule.label || field;

    if (rule.required && !value) {
      errors[field] = rule.message?.required || `${label} is required`;
      continue;
    }

    if (rule.pattern && value && !rule.pattern.test(value)) {
      errors[field] = rule.message?.pattern || ERROR_MESSAGES.pattern;
      continue;
    }

    if (rule.minLength && value.length < rule.minLength) {
      errors[field] =
        rule.message?.minLength || ERROR_MESSAGES.minLength(rule.minLength);
      continue;
    }

    if (rule.maxLength && value.length > rule.maxLength) {
      errors[field] =
        rule.message?.maxLength || ERROR_MESSAGES.maxLength(rule.maxLength);
      continue;
    }

    if (rule.custom && value) {
      const isValid = rule.custom(value);
      if (!isValid) {
        errors[field] = rule.customMessage || "Invalid value";
      }
      continue;
    }
  }

  return errors;
}

// export function validateForm(values, rules) {
//   const errors = {};

//   for (const field in values) {
//     if (!rules[field]) continue;  // skip if no validation rule

//     const value = values[field]?.toString().trim() || "";
//     const rule = rules[field];
//     const label = rule.label || field;

//     if (rule.required && !value) {
//       errors[field] = rule.message?.required || `${label} is required`;
//       continue;
//     }

//     if (rule.pattern && value && !rule.pattern.test(value)) {
//       errors[field] = rule.message?.pattern || ERROR_MESSAGES.pattern;
//       continue;
//     }

//     if (rule.minLength && value.length < rule.minLength) {
//       errors[field] =
//         rule.message?.minLength || ERROR_MESSAGES.minLength(rule.minLength);
//       continue;
//     }

//     if (rule.maxLength && value.length > rule.maxLength) {
//       errors[field] =
//         rule.message?.maxLength || ERROR_MESSAGES.maxLength(rule.maxLength);
//       continue;
//     }
//   }

//   for (const field in rules) {
//     const rule = rules[field];
//     const label = rule.label || field;
//     const value = values[field]?.toString().trim() || "";

//     if (rule.required && !value) {
//       errors[field] = errors[field] || rule.message?.required || `${label} is required`;
//     }
//   }

//   return errors;
// }
